import React from "react";
import styles from "./styles/HeroRightCard.module.css";

export default function HeroRightCard({
  hasLearners,
  learners,
  router,
  onAddLearner,
}) {
  return (
    <div className={styles.heroCard}>
      <h4 className={styles.heroCardTitle}>
        {hasLearners
          ? "Your Learners"
          : "Start by adding your first learner"}
      </h4>

      {hasLearners && (
        <ul className={styles.heroLearnersList}>
          {learners.map((learner) => (
            <li
              key={learner.id || learner.name}
              className={styles.heroLearnerItem}
              onClick={() => router.push(`/student-page/${learner.id}`)}
            >
              <div className={styles.heroLearnerAvatar}>
                {learner.avatarUrl ? (
                  <img
                    src={learner.avatarUrl}
                    alt={learner.name || "Learner avatar"}
                    className={styles.heroLearnerAvatarImg}
                  />
                ) : (
                  <span>☀️</span>
                )}
              </div>

              <div className={styles.heroLearnerInfo}>
                <span className={styles.heroLearnerName}>
                  {learner.name || learner.firstName || "Learner"}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}

      <button
        type="button"
        onClick={onAddLearner}
        className={styles.primaryButtonFull}
      >
        Add learner
      </button>
    </div>
  );
}